exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tree {\n  height: 800px;\n  width: 90%;\n}\n.private-layers {\n  margin-top: 30px;\n  margin-left: 7px;\n  margin-bottom: 7px;\n}\n /deep/ tree-viewport {\n  overflow: hidden;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/layers-manager/components/layer-tree/layer-tree.component.less
// module id = ../../../../../src/app/packages/menu-items/layers-manager/components/layer-tree/layer-tree.component.less
// module chunks = main